import { createBrowserHistory } from 'history';
import { stripRoutingSegment } from '../utils/uriUtils';

const getCurrentUriRef = ({ pathname, search }) => {
    const currentUriRef = stripRoutingSegment(`${pathname}${search}`);
    return decodeURIComponent(currentUriRef);
};

export class FindingRouter {
    constructor(options) {
        const { routes, initialUriRef } = options;

        this.routes = routes;
        this.history = createBrowserHistory();
        this.previousDisplayUriRef = initialUriRef;
    }

    navigate(displayUriRef, options = {}) {
        const { replace } = options;
        const { pathname, search, hash } = this.history.location;
        const currentUriRef = getCurrentUriRef({ pathname, search, hash }); // what's currently in the browser address bar minus oq hash param

        if (displayUriRef !== currentUriRef) {
            if (replace) {
                this.history.replace(displayUriRef);
            } else {
                //update browser url bar if URI changes in the store
                this.history.push(displayUriRef);
                // keep track of previous push so we don't push any history twice
                this.previousDisplayUriRef = displayUriRef;
            }
        }
    }
}
